// extracted by mini-css-extract-plugin
export default {"page":"LegalDoc_page__-e+Ju","doc":"LegalDoc_doc__jjiu4","date":"LegalDoc_date__tksAX"};